import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { useTranslate } from '@tolgee/react';
import { generateHtmlId } from '@amf/shared/utils/id';

interface TextAreaProps extends Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'value'> {
  label: string;
  accessory?: ReactNode;
  error?: string;
  children?: ReactNode;
  dark?: boolean;
  fieldSize?: 'normal' | 'small';
  value?: string | ReadonlyArray<string> | number | null;
}

// eslint-disable-next-line react/display-name
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    { label, accessory, placeholder, error, className, dark, children, fieldSize, value, ...props },
    ref,
  ) => {
    const { t } = useTranslate();
    const id = generateHtmlId();
    return (
      <div
        className={classNames(
          'FormField',
          'FormField--textArea',
          {
            'FormField--dark': dark,
            'FormField--withError': error,
            'FormField--small': fieldSize === 'small',
          },
          className,
        )}
      >
        <textarea
          {...props}
          id={id}
          ref={ref}
          className='FormField__input FormField__input--textArea'
          placeholder={placeholder ?? ' '}
          value={value === null ? '' : value}
        />
        <label htmlFor={id} className='FormField__label'>
          {label}
        </label>
        {accessory && <div className='FormField__accessory'>{accessory}</div>}
        {children}
        {error && <p className='FormField__error'>{t(error)}</p>}
      </div>
    );
  },
);

export default TextArea;
